import { render, staticRenderFns } from "./search.vue?vue&type=template&id=1613e759&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=1613e759&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613e759",
  null
  
)

export default component.exports